import { Block, Button } from "framework7-react";
import { isStandalone } from "../../utils/install-platform";

const TransferPrompt = ({ onEnterCode }) => (
  <Block className="transfer-prompt">
    <span>
      {isStandalone()
        ? "Schon im Browser genutzt?"
        : "Schon auf einem anderen Gerät genutzt?"}
    </span>
    <Button onClick={onEnterCode}>Code eingeben</Button>
  </Block>
);

export default TransferPrompt;
